module.exports = __webpack_public_path__ + "static/harris-blu-d85101796f596e35a6b2ad65b4de194d.jpeg";